import { connect } from "react-redux";
import SettingsMobile from "./settings_mobile";
import React from "react";
import { openModal, closeModal } from "../actions/modal_actions";
import { fetchServices } from "../actions/service_actions";
import { withRouter } from "react-router-dom";
import { logout } from "../actions/session_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  currentUser: state.entities.users[state.session.currentUser.id],
});

const mdp = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default withRouter(connect(msp, mdp)(SettingsMobile));